module.exports = __webpack_public_path__ + "img/sld_step_down_transformer_h_r1_l1_dark.06cb62f2.svg";